import CrudCustom from '../../../libs/custom/CrudCustom';

let BiayaJabatanService = new CrudCustom('/biaya-jabatans');
export default BiayaJabatanService;
